import React from 'react'

const Map = () => {
  return (
      <img
          src="https://www.w3schools.com/w3images/map.jpg"
          className="w3-image w3-greyscale"
          style={{ width: "100%" }}
    />
  )
}

export default Map